class ClockEventRegistrationResult {

  constructor(handlers, handler) {

    this.handlers = handlers;
    this.handler = handler;

  }

  cancel() {

    this.handlers.splice(this.handlers.indexOf(this.handler), 1);

  }

}

class Clock {

  constructor() {

    this.processInterval = 500;
    this.baseTimerReference = null;

    this.secondPulseLastProcessedAt = new Date(); // initializing with past value for first time trigger.
    this.minutePulseLastProcessedAt = new Date(); // initializing with past value for first time trigger.

    this.newSecondHandlers = [];
    this.newMinuteHandlers = [];

    this.secondAndProcessingDetailsMap = {};
    this.minuteAndProcessingDetailsMap = {};

    this.everyNthSecondAndProcessingDetailsMap = {};

  }

  callHandlers(handlers) {

    for (let handler of handlers) {

      try {

        handler();

      } catch (exception) {

        // eslint-disable-next-line no-console
        console.error(exception);

      }

    }

  }

  onNewSecond(handler) {

    this.newSecondHandlers.push(handler);

    const result = new ClockEventRegistrationResult(this.newSecondHandlers, handler);

    return result;

  }

  onNewMinute(handler) {

    this.newMinuteHandlers.push(handler);

    const result = new ClockEventRegistrationResult(this.newMinuteHandlers, handler);

    return result;

  }

  onSecond(second, handler) {

    const processingDetails = this.secondAndProcessingDetailsMap[second] || {
      handlers: [],
      lastProcessedAt: new Date() // initializing with past value for first time trigger.
    };

    const handlers = processingDetails.handlers;

    handlers.push(handler);

    this.secondAndProcessingDetailsMap[second] = processingDetails;

    const result = new ClockEventRegistrationResult(handlers, handler);

    return result;

  }

  onMinute(minute, handler) {

    const processingDetails = this.minuteAndProcessingDetailsMap[minute] || {
      handlers: [],
      lastProcessedAt: new Date() // initializing with past value for first time trigger.
    };

    const handlers = processingDetails.handlers;

    handlers.push(handler);

    this.minuteAndProcessingDetailsMap[minute] = processingDetails;

    const result = new ClockEventRegistrationResult(handlers, handler);

    return result;

  }

  everyNthSecond(second, handler) {

    const processingDetails = this.everyNthSecondAndProcessingDetailsMap[second] || {
      handlers: [],
      lastProcessedAt: new Date()
    };

    const handlers = processingDetails.handlers;

    handlers.push(handler);

    this.everyNthSecondAndProcessingDetailsMap[second] = processingDetails;

    const result = new ClockEventRegistrationResult(handlers, handler);

    return result;

  }

  processSecondPulse() {

    const lastProcessedAt = this.secondPulseLastProcessedAt;
    const now = new Date();

    if (lastProcessedAt.getSeconds() === now.getSeconds()) {
      return;
    }

    const handlers = this.newSecondHandlers;

    this.callHandlers(handlers);

    this.secondPulseLastProcessedAt = now;

  }

  processNthSecondPulse() {

    const now = new Date();
    const seconds = now.getSeconds();

    const processingDetails = this.secondAndProcessingDetailsMap[seconds];

    if (typeof processingDetails === 'undefined') {
      return;
    }

    const lastProcessedAt = processingDetails.lastProcessedAt;

    if (now.getMinutes() === lastProcessedAt.getMinutes()) {
      return;
    }

    this.callHandlers(processingDetails.handlers);

    processingDetails.lastProcessedAt = now;

  }

  processEveryNthSecondPulse() {

    const now = new Date();
    const seconds = now.getSeconds();

    const nthSeconds = Object.keys(this.everyNthSecondAndProcessingDetailsMap);

    for (let nthSecond of nthSeconds) {

      const processingDetails = this.everyNthSecondAndProcessingDetailsMap[nthSecond];
      const handlers = processingDetails.handlers;

      if (handlers.length === 0) {
        continue;
      }

      if ((seconds % nthSecond) !== 0) {
        continue;
      }

      if (seconds === processingDetails.lastProcessedAt.getSeconds()) {
        continue;
      }

      this.callHandlers(handlers);

      processingDetails.lastProcessedAt = now;

    }

  }

  processMinutePulse() {

    const lastProcessedAt = this.minutePulseLastProcessedAt;
    const now = new Date();

    if (lastProcessedAt.getMinutes() === now.getMinutes()) {
      return;
    }

    this.callHandlers(this.newMinuteHandlers);

    this.minutePulseLastProcessedAt = now;

  }

  processNthMinutePulse() {

    const now = new Date();
    const minutes = now.getMinutes();

    const processingDetails = this.minuteAndProcessingDetailsMap[minutes];

    if (typeof processingDetails === 'undefined') {
      return;
    }

    const lastProcessedAt = processingDetails.lastProcessedAt;

    if (lastProcessedAt.getHours() === now.getHours()) {
      return;
    }

    this.callHandlers(processingDetails.handlers);

    processingDetails.lastProcessedAt = now;

  }

  async processPulse() {

    this.processSecondPulse();
    this.processNthSecondPulse();
    this.processEveryNthSecondPulse();
    this.processMinutePulse();
    this.processNthMinutePulse();

  }

  start() {

    const milliseconds = (new Date()).getMilliseconds();
    let delay = this.processInterval - milliseconds;

    if (milliseconds > this.processInterval) {
      delay = this.processInterval + (this.processInterval - milliseconds);
    }

    setTimeout(function callback() {
      this.processPulse();
      this.baseTimerReference = setInterval(function baseTimer() {
        this.processPulse();
      }.bind(this), this.processInterval);
    }.bind(this), delay);

  }

  stop() {

    clearInterval(this.baseTimerReference);

  }

}

export default Clock;